import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { InputLabel, PayOnline } from "./StyledComponents";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const validationSchema = Yup.object().shape({
    email: Yup.string()
        .matches(emailRegex, "Invalid email format")
        .required("Email is required"),
});

const EmailStep = ({ userEmail, setUserEmail, setStep }) => {
    return (
        <div className="px-4 py-4">
            <Formik
                initialValues={{ email: userEmail || "" }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    setUserEmail(values.email);
                    setStep(3);
                }}
            >
                {({ handleSubmit, errors, touched }) => (
                    <Form onSubmit={handleSubmit}>
                        <InputLabel>Email *</InputLabel>
                        <Field
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            className="w-full px-2 h-11 border rounded-lg"
                        />
                        {errors.email && touched.email && (
                            <div className="text-red-500 text-sm">{errors.email}</div>
                        )}
                        <div className="flex justify-center items-center mt-5 gap-4">
                            <PayOnline type="submit">Continue</PayOnline>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EmailStep;